(() => {
  const products = new Map();
  const cacheKey = 'linkedoption-color-cards-v1';
  const cachedGroups = () => {
    try { return JSON.parse(sessionStorage.getItem(cacheKey) || '{}'); } catch { return {}; }
  };
  const loadProduct = (url) => {
    const endpoint = new URL(url, location.origin);
    endpoint.search = '';
    endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
    if (!products.has(endpoint.href)) {
      products.set(endpoint.href, fetch(endpoint.href).then((response) => {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      }).catch(() => {
        products.delete(endpoint.href);
        return null;
      }));
    }
    return products.get(endpoint.href);
  };

  const expandRelated = (linked) => {
    linked.querySelectorAll('.lv-option-item-link').forEach(async (original) => {
      const source = original.closest('.lv-option-wrapper');
      if (!source || source.hidden || source.dataset.colorExpansion) return;
      source.dataset.colorExpansion = 'loading';
      const product = await loadProduct(original.href);
      if (!product || !source.isConnected) {
        source.dataset.colorExpansion = 'failed';
        original.classList.remove('linkedoption-color-cards__loading');
        return;
      }
      const index = product.options.findIndex((option) => /^(colou?r|couleur|farbe|цвет)$/i.test(typeof option === 'string' ? option : option.name));
      if (index < 0) {
        source.dataset.colorExpansion = 'failed';
        original.classList.remove('linkedoption-color-cards__loading');
        return;
      }
      const colors = new Map();
      product.variants.forEach((variant) => {
        const color = variant.options[index];
        if (!colors.has(color) || (!colors.get(color).available && variant.available) || (!colors.get(color).featured_image && variant.featured_image)) {
          colors.set(color, variant);
        }
      });
      if (!colors.size) {
        source.dataset.colorExpansion = 'failed';
        original.classList.remove('linkedoption-color-cards__loading');
        return;
      }
      // const images = await Promise.all(Array.from(colors.values()).map((variant) => {
      //   if (!variant.featured_image?.src) return Promise.resolve(null);
      //   const image = new Image();
      //   return new Promise((resolve) => {
      //     image.onload = () => resolve(variant.featured_image.src);
      //     image.onerror = () => resolve(null);
      //     image.src = variant.featured_image.src;
      //     if (image.complete) resolve(image.naturalWidth ? variant.featured_image.src : null);
      //   });
      // }));
      const images = Array.from(colors.values()).map(
        (variant) => variant.featured_image?.src || null
      );
      if (!source.isConnected) return;
      Array.from(colors).forEach(([color, variant], index) => {
        const key = product.id + ':' + color;
        if (Array.from(linked.querySelectorAll('[data-card-key]')).some((item) => item.dataset.cardKey === key)) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'lv-option-wrapper linkedoption-color-cards__related';
        const card = document.createElement('a');
        card.className = 'lv-option-item-outer';
        card.dataset.cardKey = key;
        card.title = color;
        card.setAttribute('aria-label', product.title + ' — ' + color);
        const url = new URL(original.href, location.origin);
        url.searchParams.set('variant', variant.id);
        card.href = url.href;
        if (images[index]) {
          const image = document.createElement('img');
          image.className = 'linkedoption-color-cards__image';
          image.src = images[index];
          image.alt = '';
          image.width = 72;
          image.height = 72;
          image.addEventListener('error', () => card.classList.add('color-image-card--error'), { once: true });
          card.append(image);
        }
        const fallback = document.createElement('span');
        fallback.className = 'linkedoption-color-cards__fallback';
        fallback.textContent = color;
        card.append(fallback);
        wrapper.append(card);
        source.before(wrapper);
      });
      source.hidden = true;
      source.dataset.colorExpansion = 'done';
    });
  };
  const colorFieldset = (scope) => Array.from(scope.querySelectorAll('variant-selects fieldset')).find((fieldset) => {
    const legend = fieldset.querySelector('legend');
    return /^(Color|Colour|Couleur|Farbe|Цвет)\s*:/i.test(legend?.textContent?.trim() || '');
  });

  const setLabel = (label, value) => {
    const locale = document.documentElement.lang.split('-')[0];
    const prefix = { fr: 'Couleur', de: 'Farbe', ru: 'Цвет', es: 'Color' }[locale] || 'Color';
    const text = prefix + ': ' + (value || '');
    if (label.textContent !== text) label.textContent = text;
  };

  const selectedColor = (productInfo, fieldset) => {
    return productInfo.querySelector('.linkedoption-color-cards__native input[type="radio"]:checked')?.value
      || fieldset.querySelector('input[type="radio"]:checked')?.value
      || '';
  };

  const saveGroup = async (app, linked, productInfo) => {
    const gid = app.dataset.gid;
    if (!gid || app.dataset.colorCacheSaved) return;
    app.dataset.colorCacheSaved = 'true';
    const product = await loadProduct(location.pathname);
    if (!product) return;
    const index = product.options.findIndex((option) => /^(colou?r|couleur|farbe|цвет)$/i.test(typeof option === 'string' ? option : option.name));
    const cards = Array.from(linked.querySelectorAll('.linkedoption-color-cards__native .lv-option-item-outer, .linkedoption-color-cards__related .lv-option-item-outer')).map((card) => {
      const native = card.dataset.nativeColor;
      const variant = native && product.variants.find((item) => item.options[index] === native);
      const image = card.querySelector('img')?.src || (card.style.backgroundImage.match(/^url\(["']?(.*?)["']?\)$/) || [])[1] || '';
      return { productId: native ? String(product.id) : card.dataset.cardKey?.split(':')[0], color: native || card.title, href: native && variant ? location.pathname + '?variant=' + variant.id : card.href, image };
    }).filter((card) => card.productId && card.href && card.image);
    if (cards.length < 2) return;
    try {
      const groups = cachedGroups();
      groups[gid] = cards;
      sessionStorage.setItem(cacheKey, JSON.stringify(groups));
    } catch { /* Storage may be unavailable. */ }
  };

  const showTemplatePreview = (productInfo, fieldset) => {
    const existing = fieldset.querySelector('.linkedoption-color-cards__preview');
    if (existing) {
      existing.querySelectorAll('[data-native-color]').forEach((card) => {
        card.classList.toggle('lv-option-item__active', card.dataset.nativeColor === selectedColor(productInfo, fieldset));
      });
      return;
    }
    const template = document.getElementById('king-linked-option-product-tpl');
    const templateApp = template?.content?.querySelector('king-linked-options-product');
    const cached = Object.values(cachedGroups()).find((cards) => Array.isArray(cards) && cards.some((card) => card.productId === productInfo.dataset.productId));
    if (!cached && (!templateApp || templateApp.dataset.pid !== productInfo.dataset.productId)) return;
    const preview = document.createElement('div');
    preview.className = 'linkedoption-color-cards__preview';
    if (cached) {
      cached.forEach((item) => {
        const input = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((radio) => radio.value === item.color);
        const native = item.productId === productInfo.dataset.productId && input;
        const card = document.createElement(native ? 'button' : 'a');
        if (native) {
          card.type = 'button';
          card.dataset.nativeColor = item.color;
          card.classList.toggle('lv-option-item__active', input.checked);
          card.addEventListener('click', () => input.click());
        } else card.href = item.href;
        card.setAttribute('aria-label', item.color);
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.width = 72;
        image.height = 72;
        image.loading = 'eager';
        image.addEventListener('error', () => card.classList.add('color-image-card--error'), { once: true });
        card.append(image);
        const fallback = document.createElement('span');
        fallback.textContent = item.color;
        card.append(fallback);
        preview.append(card);
      });
      fieldset.append(preview);
      return;
    }
    const nativeCards = [];
    fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
      const label = input.nextElementSibling;
      const card = document.createElement('button');
      card.type = 'button';
      card.dataset.nativeColor = input.value;
      card.setAttribute('aria-label', input.value);
      card.classList.toggle('lv-option-item__active', input.checked);
      const sourceImage = label?.querySelector('img') || fieldset.querySelector('.linkedoption-color-cards__pending img');
      if (sourceImage?.src) {
        const image = document.createElement('img');
        image.src = sourceImage.src;
        image.alt = '';
        image.width = 72;
        image.height = 72;
        image.loading = 'eager';
        image.addEventListener('error', () => card.classList.add('color-image-card--error'), { once: true });
        card.append(image);
        if (image.complete && !image.naturalWidth) card.classList.add('color-image-card--error');
      }
      const fallback = document.createElement('span');
      fallback.textContent = input.value;
      card.append(fallback);
      card.addEventListener('click', () => input.click());
      nativeCards.push(card);
    });
    let insertedNative = false;
    templateApp.querySelectorAll('.lv-option-item-link').forEach((original) => {
      if (original.dataset.pid === productInfo.dataset.productId) {
        if (!insertedNative) preview.append(...nativeCards);
        insertedNative = true;
        return;
      }
      const card = document.createElement('a');
      card.href = new URL(original.getAttribute('href'), location.origin).href;
      card.setAttribute('aria-label', original.getAttribute('aria-label') || 'View related color');
      const sourceImage = original.querySelector('img');
      if (sourceImage?.src) {
        const image = document.createElement('img');
        image.src = sourceImage.src;
        image.alt = '';
        image.width = 72;
        image.height = 72;
        image.loading = 'eager';
        image.addEventListener('error', () => card.classList.add('color-image-card--error'), { once: true });
        card.append(image);
        if (image.complete && !image.naturalWidth) card.classList.add('color-image-card--error');
      }
      const fallback = document.createElement('span');
      fallback.textContent = original.dataset.value || 'View';
      card.append(fallback);
      preview.append(card);
    });
    if (!insertedNative) preview.prepend(...nativeCards);
    if (preview.childElementCount) fieldset.append(preview);
  };

  const sync = () => {
    document.querySelectorAll('.color-image-card__image, .linkedoption-color-cards__pending img').forEach((image) => {
      if (image.complete && !image.naturalWidth) image.parentElement.classList.add('color-image-card--error');
    });
    document.querySelectorAll('product-info').forEach((productInfo) => {
      const fieldset = colorFieldset(productInfo);
      if (!fieldset) return;

      const linked = productInfo.querySelector('king-linked-options-product .lv-option-group');
      const app = linked?.closest('king-linked-options-product');
      const size = Array.from(productInfo.querySelectorAll('variant-selects fieldset')).find((item) => {
        const legend = item.querySelector('legend');
        return /^(Size|Taille|Größe|Размер|Talla|Tamaño)\s*:/i.test(legend?.textContent?.trim() || '');
      });
      const legend = fieldset.querySelector('legend');
      const current = selectedColor(productInfo, fieldset);

      // The variant picker may be replaced after the linked cards become ready.
      // Hide the replacement immediately, including its duplicate Color legend.
      if (app?.classList.contains('linkedoption-color-cards__ready')) {
        fieldset.classList.add('linkedoption-color-cards__source');
        fieldset.style.setProperty('display', 'none', 'important');
      }

      if (!app?.classList.contains('linkedoption-color-cards__ready')) showTemplatePreview(productInfo, fieldset);

      if (!linked || !app || !linked.querySelector('.lv-option-item-link')) {
        return;
      }
      if (fieldset.querySelector('[data-color-card]')) fieldset.dataset.imageCardsReady = 'true';
      if (fieldset.dataset.imageCardsReady !== 'true') {
        if (fieldset.dataset.imageCardsLoading === 'true') return;
        fieldset.dataset.imageCardsLoading = 'true';
        loadProduct(productInfo.querySelector('variant-selects').dataset.url || location.pathname).then((product) => {
          if (!product || !fieldset.isConnected) return;
          const index = product.options.findIndex((option) => /^(colou?r|couleur|farbe|цвет)$/i.test(typeof option === 'string' ? option : option.name));
          fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
            const label = fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]');
            const variant = product.variants.find((item) => item.options[index] === input.value && item.featured_image?.src);
            const image = variant?.featured_image?.src || (fieldset.hasAttribute('data-single-color-picker') ? product.featured_image : null);
            if (!label || !image) return;
            label.dataset.colorCard = '';
            label.dataset.productId = product.id;
            label.style.backgroundImage = 'url(' + JSON.stringify(image) + ')';
          });
          fieldset.dataset.imageCardsReady = 'true';
          sync();
        });
        return;
      }
      if (legend) setLabel(legend, current);

      let label = productInfo.querySelector('.linkedoption-color-cards__label');
      if (!label) {
        label = document.createElement('div');
        label.className = 'linkedoption-color-cards__label';
        app.before(label);
      }
      setLabel(label, current);

      if (fieldset.dataset.linkedoptionMerged !== 'true') {
        linked.querySelectorAll('.linkedoption-color-cards__native').forEach((item) => item.remove());

        Array.from(fieldset.querySelectorAll('input[type="radio"]')).forEach((input) => {
          const card = input.nextElementSibling;
          if (!card?.matches('[data-color-card]')) return;

          const wrapper = document.createElement('div');
          wrapper.className = 'lv-option-wrapper linkedoption-color-cards__native';
          const proxy = document.createElement('button');
          proxy.type = 'button';
          proxy.className = 'lv-option-item-outer';
          proxy.dataset.nativeColor = input.value;
          proxy.dataset.cardKey = card.dataset.productId + ':' + input.value;
          proxy.title = input.value;
          proxy.setAttribute('aria-label', input.value);
          const sourceImage = card.querySelector('img');
          if (sourceImage?.src) {
            const image = document.createElement('img');
            image.className = 'linkedoption-color-cards__image';
            image.src = sourceImage.src;
            image.alt = '';
            image.width = 72;
            image.height = 72;
            image.addEventListener('error', () => proxy.classList.add('color-image-card--error'), { once: true });
            proxy.append(image);
            if (image.complete && !image.naturalWidth) proxy.classList.add('color-image-card--error');
          } else if (card.style.backgroundImage) {
            proxy.style.backgroundImage = card.style.backgroundImage;
          }
          if (!card.style.backgroundImage) {
            const fallback = document.createElement('span');
            fallback.className = 'linkedoption-color-cards__fallback';
            fallback.textContent = input.value;
            proxy.append(fallback);
          }
          proxy.addEventListener('click', () => input.click());
          wrapper.append(proxy);
          const currentCard = Array.from(linked.querySelectorAll('.lv-option-item-link')).find((item) => item.dataset.pid === card.dataset.productId);
          if (currentCard) {
            currentCard.closest('.lv-option-wrapper').before(wrapper);
            currentCard.closest('.lv-option-wrapper').hidden = true;
          } else linked.append(wrapper);
        });

        fieldset.dataset.linkedoptionMerged = 'true';
      }

      linked.querySelectorAll('[data-native-color]').forEach((card) => {
        card.classList.toggle('lv-option-item__active', card.dataset.nativeColor === current);
        card.setAttribute('aria-pressed', String(card.dataset.nativeColor === current));
      });
      expandRelated(linked);

      if (size && !(label.nextElementSibling === app && app.nextElementSibling === size)) {
        size.before(label, app);
      }
      const allExpanded = Array.from(linked.querySelectorAll('.lv-option-item-link')).every((item) => {
        const source = item.closest('.lv-option-wrapper');
        return source?.hidden || source?.dataset.colorExpansion === 'failed';
      });
      if (allExpanded) {
        fieldset.classList.add('linkedoption-color-cards__source');
        fieldset.style.setProperty('display', 'none', 'important');
        productInfo.querySelector('.linkedoption-color-cards__preview')?.remove();
        app.classList.add('linkedoption-color-cards__ready');
        saveGroup(app, linked, productInfo);
      }
    });
  };

  new MutationObserver(sync).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('error', (event) => {
    if (event.target.matches?.('.color-image-card__image, .linkedoption-color-cards__pending img')) {
      event.target.parentElement.classList.add('color-image-card--error');
    }
  }, true);
  document.addEventListener('change', sync);
  sync();
})();
